<template>
  <transition name="fade">
    <div class="ui-popver-wrapper" v-show="value" @click.self="handleClickModal">
      <div class="container">
        <slot></slot>
        <i class="icon-close" @click.self="handleClose"></i>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Pover",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClose() {
      this.$emit("input", false)
    },
    handleClickModal() {
      this.closeOnClickModal && this.handleClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-popver-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  .container {
    width: 6.4rem;
    height: auto;
    border-radius: 0.2rem;
    overflow: hidden;
    background: #ffffff;
    position: relative;
    padding-top: 0.8rem;
    .icon-close {
      background: url("../../assets/images/icon_close.png") no-repeat center;
      background-size: 0.2rem 0.2rem;
      display: inline-block;
      height: 0.8rem;
      width: 0.8rem;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

.fade-enter,
.fade-leave-to {
  &.ui-popver-wrapper {
    background: rgab(0, 0, 0, 0);
  }
}

.fade-leave-to {
  &.ui-popver-wrapper {
    opacity: 0;
  }
}

.fade-enter-to {
  &.ui-popver-wrapper {
    background: rgab(0, 0, 0, 0.5);
  }
}

.fade-leave {
  &.ui-popver-wrapper {
    opacity: 1;
  }
}

.fade-enter-active {
  &.ui-popver-wrapper {
    transition: all 0.3s ease-in-out;
    .container {
      animation: scaleFade 0.3s ease-in-out;
    }
  }
}

.fade-leave-active {
  &.ui-popver-wrapper {
    transition: all 0.3s ease-in-out;
  }
}

@keyframes scaleFade {
  0% {
    transform: scale(0.95);
    opacity: 0.5;
  }
  45% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
